<div class="modal-header">
  <h4 class="modal-title">{{'editProjectArticleNumber.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label" for="articleNumber">{{'finalizeProject.label.articleNumber' | translate}}: </label>
        <div class="col-md-8">
          <input class="form-control" formControlName="{{articleNumberTextInputName}}" type="text"
                 inputRestricter="^[0-9A-Z-/]*$" maxlength="{{maxArticleNumberChars}}"
                 id="articleNumber"
                 [class.is-invalid]="form.controls[articleNumberTextInputName]?.invalid">
          <div class="invalid-feedback">{{form.controls[articleNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberTextInputName]?.errors?.param} }}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label"></label>
        <div class="col-md-8 col-form-label">
          <div class="form-check" *ngIf="isAutomaticGenerationAvailable">
            <input [checked]="isAutomaticGenerationSelected" class="form-check-input" id="generateArticleNumber" type="checkbox" (change)="isAutomaticGenerationSelected = !isAutomaticGenerationSelected">
            <label class="form-check-label" for="generateArticleNumber">{{'finalizeProject.label.generateArticleNumber' | translate}}</label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button" class="btn btn-primary btn-forward" (click)="save()" [disabled]="form.controls[articleNumberTextInputName]?.errors" >
    {{'global.label.save' | translate}}
  </button>
</div>
